var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 127,
    viewBox: "0 0 135 127",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.956%",
    y1: "131.719%",
    x2: "49.956%",
    y2: "6.753%",
    id: "k7oai37eua"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AB5A0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7AED2",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.967%",
    y1: "-2.301%",
    x2: "49.967%",
    y2: "101.074%",
    id: "nd5x89getb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF0F5",
    offset: "99.64%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.711%",
    y1: "53.572%",
    x2: "47.948%",
    y2: "46.462%",
    id: "vve34soa5c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D8E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E4F0",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.968%",
    y1: "-2.316%",
    x2: "49.968%",
    y2: "101.076%",
    id: "ki6eh75ylf"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF0F5",
    offset: "99.64%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-42.3%",
    y: "-49.1%",
    width: "184.6%",
    height: "237.5%",
    filterUnits: "objectBoundingBox",
    id: "y11bt9mrjd"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 11,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.396078431 0 0 0 0 0.478431373 0 0 0 0 0.576470588 0 0 0 0.27 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109 38v46.982c-.096 2.688-1.346 4.99-3.27 6.622-1.636 1.434-3.848 2.396-6.253 2.396h-75.32c-1.636 0-3.175-.387-4.521-1.15-.578-.293-1.155-.67-1.636-1.152l4.81-2.877 37.804-22.246 1.251-.764 1.154-.67L104 40.877 109 38z",
    id: "6om7yq51be"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5 102c28.438 0 51.5-22.82 51.5-51S93.938 0 65.5 0 14 22.82 14 51s23.062 51 51.5 51z",
    fill: "#D1EEDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.5 27c1.934 0 3.5-1.562 3.5-3.5 0-1.93-1.566-3.5-3.5-3.5-1.933 0-3.5 1.57-3.5 3.5 0 1.938 1.567 3.5 3.5 3.5z",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5 15c1.38 0 2.5-1.116 2.5-2.5s-1.12-2.5-2.5-2.5a2.498 2.498 0 0 0-2.5 2.5c0 1.384 1.119 2.5 2.5 2.5zM13.5 23c1.38 0 2.5-1.116 2.5-2.5S14.88 18 13.5 18a2.498 2.498 0 0 0-2.5 2.5c0 1.384 1.119 2.5 2.5 2.5z",
    fill: "#D1EEDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 77c2.485 0 4.5-2.016 4.5-4.5S10.985 68 8.5 68a4.501 4.501 0 0 0 0 9z",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 38.678V85.93c-.097 2.704-1.359 5.019-3.3 6.66-1.65 1.443-3.881 2.41-6.307 2.41h-75.98c-1.65 0-3.203-.389-4.562-1.158-.582-.293-1.164-.673-1.65-1.157-1.067-.873-2.037-2.125-2.522-3.473-.389-.967-.679-2.03-.679-3.084v-47.45s3.978-3.369 9.704-7.999c5.919-4.915 13.681-11.281 20.475-16.879 3.881-3.274 3.493-2.894 9.509-7.904a12.247 12.247 0 0 1 15.817 0c1.165.967 2.426 2.125 3.59 3.084 2.524 2.03 5.24 4.345 8.152 6.755 6.113 5.01 12.81 10.608 18.05 14.944 5.336 4.337 9.217 7.62 9.703 8z",
    fill: "#5DC389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 29.786v16.776l-16.42 9.935-4.898 2.99-10.371 6.271-4.899 2.99L64.3 70l-2.017-1.253-4.61-2.989-9.89-6.272-4.61-2.989L28 46.951v-17.07C33.858 24.965 41.54 18.598 48.263 13l36.78 1.831c6.146 5.115 12.771 10.61 17.957 14.955z",
    fill: "#18A957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 17.579v29.442l-14.899 8.947-4.393 2.698-9.455 5.576-4.394 2.698L63.95 68l-1.814-1.06-4.202-2.698-8.978-5.576-4.202-2.698L31 47.314V17.58c0-3.077 2.484-5.576 5.636-5.576h56.73C96.42 11.908 99 14.502 99 17.579z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 38 45.155 2.979L108 38l-1.825 8.557S61.212 70 61.5 70c.288 0-46.404-27.773-46.404-27.773L15 38z",
    fill: "url(#k7oai37eua)",
    fillRule: "nonzero",
    opacity: 0.5,
    transform: "translate(4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 38v46.982c-.097 2.688-1.359 4.99-3.3 6.622-1.65 1.434-3.881 2.396-6.307 2.396h-75.98c-1.65 0-3.203-.387-4.562-1.15-.582-.293-1.164-.67-1.65-1.152-1.067-.867-2.037-2.113-2.522-3.453-.389-.962-.679-2.018-.679-3.066V38l42.503 26.274 3.687 2.301 1.261-.764 1.164-.67L113 38z",
    fill: "#738DFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 91.604C103.364 93.038 101.152 94 98.747 94H23.331c-1.636 0-3.175-.387-4.522-1.15-.577-.293-1.154-.67-1.635-1.152-1.058-.867-2.02-2.113-2.501-3.453-.385-.962-.673-2.018-.673-3.066V38l4.906 2.972L61.039 65.81l1.154.67.096.094 37.805 22.246L105 91.604z",
    fill: "url(#nd5x89getb)",
    fillRule: "nonzero",
    transform: "translate(4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 65.753v3.315L19.178 94c-.583-.297-1.165-.68-1.652-1.169-1.069-.881-2.04-2.146-2.526-3.507L57.656 64l3.693 2.338.485.2L63 65.754z",
    fill: "url(#vve34soa5c)",
    fillRule: "nonzero",
    transform: "translate(4)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "m18 38 47 28"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#y11bt9mrjd)",
    xlinkHref: "#6om7yq51be"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#ki6eh75ylf)",
    xlinkHref: "#6om7yq51be"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M113 38 67.02 65.238l-1.155.779-1.25.77L22 92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.896 71H76.092c-.595 0-1.092-.449-1.092-.996 0-.547.497-1.004 1.092-1.004h25.804c.595 0 1.091.457 1.091 1.004.1.547-.396.996-1.091.996zM101.896 79H76.092C75.497 79 75 78.545 75 78c0-.545.497-1 1.092-1h25.804c.595 0 1.091.455 1.091 1 .1.545-.396 1-1.091 1z",
    fill: "#5DC389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107 94 3-1c-.093.067-.093.067-.187.128h-.094L107 94z",
    fill: "#526DFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.724 48a2.78 2.78 0 0 1-2.049-.877l-9.84-10.167c-1.113-1.155-1.113-3.082 0-4.237a2.87 2.87 0 0 1 4.097 0l7.792 8.057 18.344-18.91a2.855 2.855 0 0 1 4.097 0c1.113 1.146 1.113 3.082 0 4.228l-20.393 21.03c-.535.598-1.292.876-2.048.876z",
    fill: "#5DC389"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.1a9bc8c3d9df5b922dc08eb347b2cfc9.svg";
export { ForwardRef as ReactComponent };